import type { Address } from "@shared/api";

/** "Sam Lee" for a named address, the address itself otherwise; "me" for the owner's mailbox. */
export function addressLabel(address: Address | null | undefined, selfEmail?: string): string {
  if (!address) return "Unknown sender";
  if (selfEmail && address.email.toLowerCase() === selfEmail.toLowerCase()) return "me";
  const name = address.name?.trim().replace(/^["']|["']$/g, "");
  return name || address.email;
}

/** First names (or addresses) joined, with "+N" past `max`. */
export function participantsLabel(
  participants: readonly Address[],
  selfEmail?: string,
  max = 3,
): string {
  const labels: string[] = [];
  const seen = new Set<string>();
  for (const p of participants) {
    const key = p.email.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    const label = addressLabel(p, selfEmail);
    labels.push(label === "me" || label.includes("@") ? label : (label.split(/\s+/)[0] ?? label));
  }
  if (labels.length <= max) return labels.join(", ");
  return `${labels.slice(0, max).join(", ")} +${labels.length - max}`;
}

export function formatAddress(address: Address): string {
  const name = address.name?.trim();
  return name ? `${name} <${address.email}>` : address.email;
}

export function formatBytes(size: number): string {
  if (!Number.isFinite(size) || size < 0) return "";
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${Math.round(size / 1024)} KB`;
  return `${(size / (1024 * 1024)).toFixed(size < 10 * 1024 * 1024 ? 1 : 0)} MB`;
}
